"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgStoreCode = void 0;
var json_1 = require("../../../util/json");
var any_1 = require("@terra-money/terra.proto/google/protobuf/any");
var tx_1 = require("@terra-money/terra.proto/terra/wasm/v1beta1/tx");
var MsgStoreCode = /** @class */ (function (_super) {
    __extends(MsgStoreCode, _super);
    /**
     * @param sender code creator
     * @param wasm_byte_code base64-encoded bytecode contents
     */
    function MsgStoreCode(sender, wasm_byte_code) {
        var _this = _super.call(this) || this;
        _this.sender = sender;
        _this.wasm_byte_code = wasm_byte_code;
        return _this;
    }
    MsgStoreCode.fromAmino = function (data) {
        var _a = data.value, sender = _a.sender, wasm_byte_code = _a.wasm_byte_code;
        return new MsgStoreCode(sender, wasm_byte_code);
    };
    MsgStoreCode.prototype.toAmino = function () {
        var _a = this, sender = _a.sender, wasm_byte_code = _a.wasm_byte_code;
        return {
            type: 'wasm/MsgStoreCode',
            value: {
                sender: sender,
                wasm_byte_code: wasm_byte_code,
            },
        };
    };
    MsgStoreCode.fromProto = function (proto) {
        return new MsgStoreCode(proto.sender, Buffer.from(proto.wasmByteCode).toString('base64'));
    };
    MsgStoreCode.prototype.toProto = function () {
        var _a = this, sender = _a.sender, wasm_byte_code = _a.wasm_byte_code;
        return tx_1.MsgStoreCode.fromPartial({
            sender: sender,
            wasmByteCode: Buffer.from(wasm_byte_code, 'base64'),
        });
    };
    MsgStoreCode.prototype.packAny = function () {
        return any_1.Any.fromPartial({
            typeUrl: '/terra.wasm.v1beta1.MsgStoreCode',
            value: tx_1.MsgStoreCode.encode(this.toProto()).finish(),
        });
    };
    MsgStoreCode.unpackAny = function (msgAny) {
        return MsgStoreCode.fromProto(tx_1.MsgStoreCode.decode(msgAny.value));
    };
    MsgStoreCode.fromData = function (data) {
        var sender = data.sender, wasm_byte_code = data.wasm_byte_code;
        return new MsgStoreCode(sender, wasm_byte_code);
    };
    MsgStoreCode.prototype.toData = function () {
        var _a = this, sender = _a.sender, wasm_byte_code = _a.wasm_byte_code;
        return {
            '@type': '/terra.wasm.v1beta1.MsgStoreCode',
            sender: sender,
            wasm_byte_code: wasm_byte_code,
        };
    };
    return MsgStoreCode;
}(json_1.JSONSerializable));
exports.MsgStoreCode = MsgStoreCode;
